import { Menu, MenuItem } from '@mui/material';
import { VyTooltip } from '../../../../../components/new-design/VyTooltip';
import { INVOICE_BILLING_STATUSES, type InvoiceBillingStatus } from '@vy/types';
import { isNotNullOrUndefined, values } from '@vy/utils';
import React from 'react';
import { useMenu } from '../../../../../hooks/use-menu';
import { getBillingStatusRestriction } from '../billing-status-restrictions';
import { InvoiceBillingStatusLabel } from '../InvoiceBillingStatusLabel';

type BillingStatusMenuProps = {
  children?: React.ReactElement;
  hasNotApprovedInvoices?: boolean;
  hasPaidInvoices?: boolean;
  onUpdateInvoicesBillingStatus: (status: InvoiceBillingStatus) => void;
  onClose?: () => void;
};

export const BillingStatusMenu: React.FC<BillingStatusMenuProps> = ({
  hasNotApprovedInvoices,
  hasPaidInvoices,
  onUpdateInvoicesBillingStatus,
  onClose,
  children,
}) => {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();

  const handleItemClick = (status: InvoiceBillingStatus) => {
    onUpdateInvoicesBillingStatus(status);
    closeMenu();
  };

  const closeMenu = () => {
    handleMenuClose();
    onClose?.();
  };

  return (
    <>
      {isNotNullOrUndefined(children) &&
        React.cloneElement(children, {
          onClick: handleMenuOpen,
        })}
      <Menu
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={closeMenu}
        slotProps={{
          paper: {
            className: 'px-0 rounded-lg ml-[-24px] mt-[-14px]',
          },

          list: {
            className: 'py-2',
          }
        }}>
        <div className="space-y-1">
          {values(INVOICE_BILLING_STATUSES).map((statusItem, index) => {
            const { isDisabled, tooltipContent } = getBillingStatusRestriction(statusItem, {
              isApproved: !hasNotApprovedInvoices,
              isPaid: !!hasPaidInvoices,
              isCanceled: false,
            });

            return (
              <VyTooltip
                key={index}
                tooltipContent={tooltipContent}
                placement="right-end"
              >
                <div>
                  <MenuItem
                    onClick={() => handleItemClick(statusItem)}
                    className="px-4"
                    disabled={isDisabled}
                  >
                    <InvoiceBillingStatusLabel billingStatus={statusItem} />
                  </MenuItem>
                </div>
              </VyTooltip>
            );
          })}
        </div>
      </Menu>
    </>
  );
};
